export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="px-4 md:px-6 py-14 md:py-16 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl">🍉</span>
              <span className="text-lg font-heading text-white">51今日吃瓜</span>
            </div>
            <p className="text-sm text-white/55 leading-relaxed">
              全网热门吃瓜短视频与直播回放合集平台。实时更新，覆盖娱乐圈、网红圈、社会热点，让你随时随地吃瓜不停。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热门吃瓜', href: '#cards' },
                { label: '吃瓜视频', href: '#media' },
                { label: '话题广场', href: '#topics' },
                { label: '吃瓜热榜', href: '#ranking' },
                { label: '瓜友热评', href: '#comments' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-white/45 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-white/45">
              <span>📧 tips@51chigua.com</span>
              <span>💬 微信：51chigua_official</span>
              <span>📱 App Store / 安卓市场</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-white/35 leading-relaxed">
              诚邀各大平台与内容创作者合作，共同打造优质吃瓜生态。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/35">
            &copy; 2023-2026 51今日吃瓜 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4 text-xs text-white/35">
            <span className="cursor-pointer hover:text-primary-300 transition-colors">用户协议</span>
            <span className="cursor-pointer hover:text-primary-300 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-300 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}